export const wait = async function(dispatch, name, func) {
    dispatch('wait/start', name, { root: true });
    try {
        await func();
        dispatch('wait/end', name, { root: true });
    } catch (error) {
        dispatch('wait/end', name, { root: true });
    }
}


// WEBPACK FOOTER //
// ./src/utils/wait.js